import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';
import clsx from 'clsx';
import './Buttons.less';
const PrimaryButton1 = (props, ref) => {
    return React.createElement(BaseButton, Object.assign({ variant: 'primary', ref: ref }, props));
};
export const PrimaryButton = forwardRef(PrimaryButton1);
const SecondaryButton1 = (props, ref) => {
    return React.createElement(BaseButton, Object.assign({ variant: 'secondary', ref: ref }, props));
};
export const SecondaryButton = forwardRef(SecondaryButton1);
const TertiaryButton1 = (props, ref) => {
    const { className, lowProfile = false } = props, otherProps = __rest(props, ["className", "lowProfile"]);
    return (React.createElement(BaseButton, Object.assign({ variant: 'tertiary', className: clsx(className, lowProfile && 'low-profile'), ref: ref }, otherProps)));
};
export const TertiaryButton = forwardRef(TertiaryButton1);
const NegativeButton1 = (props, ref) => {
    return React.createElement(BaseButton, Object.assign({ variant: 'negative', ref: ref }, props));
};
export const NegativeButton = forwardRef(NegativeButton1);
//# sourceMappingURL=Buttons.js.map